import { getParentEditionFromOfferings } from '@atlassian/mpac-primitives';
import { useQueryParams } from '@atlassian/mpac-ui';
import { PlansConstants } from '@atlassian/mpac-utils';
import capitalize from 'lodash/capitalize';
import { useEffect, useMemo, useState } from 'react';
export const useSelectedEditionType = _ref => {
  let {
    eligibleOfferings
  } = _ref;
  const parentEdition = useMemo(() => getParentEditionFromOfferings(eligibleOfferings), [eligibleOfferings]);
  const {
    plan
  } = useQueryParams();
  const getDefaultEditionType = () => {
    if (typeof plan === 'string') {
      return plan;
    }
    if (parentEdition) {
      return parentEdition;
    }
    return PlansConstants.DEFAULT_SELECTED_PLAN;
  };
  const createEditionSelectValue = editionType => {
    return {
      label: capitalize(editionType),
      value: editionType
    };
  };
  const [selectedEditionType, setSelectedEditionType] = useState(createEditionSelectValue(getDefaultEditionType()));
  useEffect(() => {
    setSelectedEditionType(createEditionSelectValue(getDefaultEditionType()));
  }, [parentEdition]);
  return {
    selectedEditionType,
    setSelectedEditionType
  };
};